import AppLayout from "../Navbar/AppLayout";
import Footer from "../Navbar/Footer";
import "../../assets/css/search.scss";
import { useEffect, useMemo, useState } from "react";
import { Col, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { loadUploadedContacts } from "../redux/action";
import { MaterialReactTable } from "material-react-table";
import { useLocation } from "react-router-dom";

const ContactFilterCategories = () => {
  const dispatch = useDispatch();
  const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
  const signInID = signInDetails?.[0]?.id;

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const location = useLocation();

const searchParams = new URLSearchParams(location.search);
const filterType = searchParams.get("filter");
const filterValue = searchParams.get("value");

const filteredRows = useMemo(() => {
  const params = new URLSearchParams(location.search);
  if ([...params.keys()].length === 0) return rows;

  return rows.filter((row) => {
    return [...params.entries()].every(([type, value]) => {
      const values = value.split(",").map(v => v.trim());

      let fieldKey = "";
      switch (type) {
        case "contactType":
          fieldKey = "job_level";
          break;
        case "location":
          fieldKey = "country";
          break;
        case "company":
          fieldKey = "company";
          break;
        case "industry":
          fieldKey = "industry";
          break;
        case "technology":
          fieldKey = "technology";
          break;
        case "continent":
          fieldKey = "continent";
          break;
        default:
          return true;
      }

      if (!row[fieldKey]) return false;

      const rowValues = String(row[fieldKey])
        .split(",")
        .map((v) => v.trim().toLowerCase());

      return values.some((v) =>
        rowValues.includes(v.toLowerCase())
      );
    });
  });
}, [rows, location.search]);

// const filteredRows = useMemo(() => {
//   const params = new URLSearchParams(location.search);
//   if ([...params.keys()].length === 0) return rows;

//   return rows.filter((row) => {
//     return [...params.entries()].every(([type, value]) => {
//       const values = value.split(",");

//       let fieldKey = "";
//       switch (type) {
//         case "contactType":
//           fieldKey = "job_level";
//           break;
//         case "location":
//           fieldKey = "country";
//           break;
//         case "company":
//           fieldKey = "company";
//           break;
//         case "industry":
//           fieldKey = "industry";
//           break;
//         case "technology":
//           fieldKey = "technology";
//           break;
//         case "continent":
//           fieldKey = "continent";
//           break;
//         default:
//           return true;
//       }

//       return (
//         row[fieldKey] &&
//         values.includes(String(row[fieldKey]))
//       );
//     });
//   });
// }, [rows, location.search]);

// const filteredRows = useMemo(() => {
//   if (!filterType || !filterValue) return rows;

//   let fieldKey = "";

//   switch (filterType) {
//     case "contactType":
//       fieldKey = "job_level";
//       break;
//     case "location":
//       fieldKey = "country";
//       break;
//     case "company":
//       fieldKey = "company";
//       break;
//     case "industry":
//       fieldKey = "industry";
//       break;
//     case "technology":
//       fieldKey = "technology";
//       break;
//     case "continent":
//       fieldKey = "continent";
//       break;
//     default:
//       return rows;
//   }

//   return rows.filter(
//     (row) =>
//       row[fieldKey] &&
//       row[fieldKey].toLowerCase() === filterValue.toLowerCase()
//   );
// }, [rows, filterType, filterValue]);


  useEffect(() => {
    if (!signInID) return;

    setLoading(true);
    dispatch(
      loadUploadedContacts(
        signInID,
        (data) => {
          const transformedRows = data.map((item, index) => ({
            id: index + 1, // required unique id
            user_id: signInID,
            ...item,
          }));
          setRows(transformedRows);
          setLoading(false);
        },
        setLoading
      )
    );
  }, [dispatch, signInID]);

  // =======================
  // MRT Columns
  // =======================
  const columns = useMemo(
    () => [
      { accessorKey: "firstname", header: "First Name" },
      { accessorKey: "lastname", header: "Last Name" },
      { accessorKey: "job_level", header: "Job Level" },
      { accessorKey: "job_department", header: "Job Department" },
      { accessorKey: "job_title", header: "Title" },
      { accessorKey: "company", header: "Company" },
      { accessorKey: "website", header: "Website" },
      { accessorKey: "phone", header: "Phone" },
      { accessorKey: "email", header: "Email" },
      { accessorKey: "industry", header: "Industry" },
      { accessorKey: "sub_industry", header: "Sub Industry" },
      { accessorKey: "technology", header: "Technology" },
      { accessorKey: "city", header: "City" },
      { accessorKey: "state", header: "State" },
      { accessorKey: "country", header: "Country" },
      { accessorKey: "zipcode", header: "Zip Code" },
      { accessorKey: "sic_code", header: "SIC Code" },
      { accessorKey: "revenue", header: "Revenue" },
      { accessorKey: "employee_size", header: "Employee Size" },
    ],
    []
  );

  // =======================
  // DOWNLOAD HANDLER
  // =======================
  const handleDownload = () => {
    if (!rows.length) return;

    const selectedRowIndexes = Object.keys(rowSelection);
    const dataToDownload =
      selectedRowIndexes.length > 0
        ? selectedRowIndexes.map((i) => rows[i])
        : rows;

    const csvHeader = columns
      .map((col) => `"${col.header}"`)
      .join(",");

    const csvRows = dataToDownload.map((row) =>
      columns
        .map((col) => `"${row[col.accessorKey] ?? ""}"`)
        .join(",")
    );

    const csvData = [csvHeader, ...csvRows].join("\n");

    const blob = new Blob([csvData], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "contacts.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="page-layout">
      <AppLayout>
        <div className="page-content">
          <div className="search-contact-filter-container">
            <div
              className="search-contact-filter-container-second-div contactFilter"
              style={{ height: "100%" }}
            >
              <Col md={12}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 10,
                  }}
                >
                  <h3>Contact List</h3>
                  <Button variant="primary" onClick={handleDownload}>
                    Download
                  </Button>
                </div>

                <MaterialReactTable
                  columns={columns}
                  // data={rows}
                  data={filteredRows}
                  state={{
                    isLoading: loading,
                    rowSelection,
                  }}
                  enableRowSelection
                  onRowSelectionChange={setRowSelection}
                  getRowId={(row) => row.id}
                  initialState={{
                    pagination: { pageSize: 10, pageIndex: 0 },
                  }}
                  muiTableContainerProps={{
                    sx: {
      height: "calc(100vh - 335px)", // 🔥 adjust once
      maxHeight: "calc(100vh - 330px)",
      overflowY: "auto",
      overflowX: "auto",
    },
                  }}
                />
              </Col>
            </div>
          </div>
        </div>
      </AppLayout>
      <Footer />
    </div>
  );
};

export default ContactFilterCategories;

